import React from 'react';
import { Zap, Gift } from 'lucide-react';
export function TopBanner() {
  return <div className="w-full bg-gradient-to-r from-red-600 via-rose-600 to-red-600 text-white py-2.5 px-4 text-center text-sm font-bold tracking-wide shadow-md relative z-30" data-id="element-248">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-249">
        <Zap className="w-4 h-4 fill-amber-200 text-amber-200" data-id="element-250" />
        <span className="uppercase tracking-wider text-[12px]" data-id="element-251">
          Acceso inmediato + Bonus de regalo
        </span>
        <Gift className="w-4 h-4" data-id="element-252" />
      </div>
    </div>;
}